"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var temp = function CopyrightTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'copyright',
    theme: 'twotone',
    nameWithTheme: 'copyright-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'
      },
      children: []
    }]
  };
};

temp.nameWithTheme = 'copyright-twotone';
var CopyrightTwoTone = temp;
exports.default = CopyrightTwoTone;